module.exports = __webpack_public_path__ + "static/media/work-img12.7779e096.jpg";